import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import * as currency from '@shopify/theme-currency';
import { getSizedImageUrl } from '@shopify/theme-images';

class CartItem extends React.Component {
  constructor(props) {
    super(props);
  }

  displayQtyOptions(qty) {
    let qtyArray = new Array(9);
    if (qty > qtyArray.length) {
      qtyArray = new Array(qty);
    }
    const qtyOptions = [];

    for (let i = 0; i < qtyArray.length; i++) {
      qtyOptions.push(
        <option value={`${i + 1}`} key={`${i + 1}`}>{`${i + 1}`}</option>
      );
    }

    return qtyOptions;
  }

  handleChange(evt, id) {
    const updateCart = this.props.updateCart;
    const removeUpsell = this.props.removeUpsell;
    const qty = evt.target.value ? Number(evt.target.value) : 0;
    const data = {};
    data[id] = qty;
    axios({
      method: 'POST',
      url: '/cart/update.js',
      data: { updates: data },
      responseType: 'JSON',
    })
      .then((response) => {
        updateCart(response.data);
        if (qty === 0) {
          removeUpsell(id, response.data.items);
        }
      })
      .catch((err) => window.console.log(err));
  }

  render() {
    const { item } = this.props;

    return (
      <div className='cart-item'>
        <div className='cart-item__content-wrapper'>
          <div className='cart-item__image'>
            <a href={item.url}>
              <img
                src={getSizedImageUrl(item.image, '160x160_crop_center')}
                alt={item.title}
              />
            </a>
          </div>
          <div className='cart-item__content'>
            <div>
              <p className='cart-item__title'>{item.product_title}</p>
              <p className='cart-item__description'>{item.variant_title}</p>
            </div>
            {item.line_price > 0 && (
              <div className='quantity-selector'>
                <label>Qty.</label>
                <select
                  value={item.quantity}
                  onChange={(evt) => this.handleChange(evt, item.variant_id)}
                >
                  {this.displayQtyOptions(item.quantity)}
                </select>
              </div>
            )}
          </div>
        </div>
        <div className='cart-item__content cart-item__content--end'>
          <div
            className='cart-item__remove'
            onClick={(evt) => this.handleChange(evt, item.variant_id)}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='20'
              viewBox='0 0 20 20'
            >
              <g
                fill='none'
                fillRule='evenodd'
                stroke='#8D9794'
                strokeLinecap='square'
              >
                <path d='M4 4l12 12M16 4L4 16' />
              </g>
            </svg>
          </div>
          {currency.formatMoney(item.line_price, window.theme.moneyFormat)}
        </div>
      </div>
    );
  }
}

CartItem.propTypes = {
  item: PropTypes.object,
  updateCart: PropTypes.func,
  removeUpsell: PropTypes.func,
};

export default CartItem;
